import { ProfileTab } from './profile-tabs'

export const UserProfileTabs: Array<ProfileTab> = [
  ProfileTab.Statistics,
  // UserProfileTab.Coins,
  ProfileTab.Followers,
  ProfileTab.Following,
  ProfileTab.Transactions,
  ProfileTab.Comments,
]
